import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import locales from "../../../_constants/locales";
import "../Styles/_OrderPopupSimpleWindow.css";
import "../Styles/_ReturnOrderWindow.css";
import DataConflictWindow from "./_DataConflictWindow";
import { Confirmed } from "./_Icon";

let scrolled_into_view = false;

export class ReturnOrderWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnReasonId: null,
            returnErrorMessage: "",
            returnFinished: false,
            submitErrors: [],
            dataConflictWindowOpen: false
        };
        scrolled_into_view = false;
    }

    componentDidMount() {
        this.scrollWindowIntoView();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.setState({ returnFinished: true });
            } else {
                const errorMessage = locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER.ERROR_FAILED;
                this.setState({ returnErrorMessage: errorMessage });
            }
        }

        if (prevProps.open === false && this.props.open === true && this.props.returnReasons.length === 0 && this.props.returnReasonsLoading === false) {
            this.props.getReturnReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetReturnReason();
            this.resetReturnFinished();
            this.resetSubmitErrors();
        }
    }

    scrollWindowIntoView = () => {
        const element = document.getElementById("return-order-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "start",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    };

    postMessageToParentWindow = () => {
        const data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    };

    resetReturnFinished = () => {
        this.setState({ returnFinished: false });
    };

    handleNoClick = () => {
        if (this.state.returnFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    };

    handleYesClick = () => {
        this.resetSubmitErrors();
        const errors = this.getSubmitErrors();
        if (errors.length === 0) {
            this.props.returnOrder(
                this.props.order_id,
                {
                    order: this.props.order,
                    reason: this.state.returnReasonId
                },
                this.props.language
            );
        } else {
            this.setState({ submitErrors: errors });
        }
    };

    getSubmitErrors = () => {
        const errors = [];

        if (!this.state.returnReasonId) {
            const reasonRequired = locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.ERRORS.REASON_REQUIRED;
            errors.push({
                code: "return_reason",
                label: reasonRequired
            });
        }

        return errors;
    };

    resetSubmitErrors = () => {
        this.setState({ submitErrors: [] });
    };

    resetErrorMessages = () => {
        this.setState({ returnErrorMessage: "" });
    };

    handleChange = e => {
        if (e.target.name === "return-reason") {
            this.setState({ returnReasonId: e.target.value });
        }
    };

    resetReturnReason = () => {
        this.setState({ returnReasonId: null });
    };

    handleRefreshOrder = () => {
        this.props.handleClose();
        this.props.refreshOrder();
    };

    render() {
        const {
            ORDER_PAGE: { RETURN_SECTION },
            MISC,
            DATA_CONFLICT
        } = this.props.currentLanguage;
        return (
            <Dialog
                classes={{ paper: `popup-simple-window-dialog-paper${this.state.returnFinished ? " completed" : ""}` }}
                className="popup-simple-window-dialog"
                open={this.props.open || false}
            >
                <div
                    id="popup-simple-window"
                    className={`layout vertical popup-simple-window return-order-window relative${this.state.returnFinished ? " completed" : ""}`}
                >
                    <div className="flex layout horizontal end-justified">
                        <CloseIcon className="layout vertical center-center close-corner-button" onClick={this.handleNoClick} />
                    </div>
                    <div className="flex layout vertical relative">
                        <div className="popup-simple-window-inner">
                            {(this.props.loading || this.props.returnReasonsLoading) && (
                                <div className={`loading-box fit layout vertical center-center`}>
                                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                                </div>
                            )}
                            <div className="layout vertical header">
                                <p className="layout vertical center-center title">{RETURN_SECTION.RETURN_ORDER.HEADING}</p>
                            </div>
                            {!this.state.returnFinished && (
                                <React.Fragment>
                                    <div className="layout vertical body">
                                        <div className="sub-title">{RETURN_SECTION.RETURN_ORDER.SUBHEADING}</div>
                                        {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                            <div className="egiftcards-notice">{RETURN_SECTION.RETURN_ORDER.EGIFTCARDS_PRESENT_MESSAGE}</div>
                                        )}

                                        <div className="return-reason-box">
                                            <div className="layout vertical custom-select-box">
                                                <InputLabel className="custom-select-label">* {RETURN_SECTION.REASON_HEADER}</InputLabel>
                                                <Select
                                                    classes={{
                                                        selectMenu: "custom-select-menu"
                                                    }}
                                                    name="return-reason"
                                                    MenuProps={{
                                                        variant: "menu",
                                                        getContentAnchorEl: null,
                                                        classes: {
                                                            paper: "custom-select-menu-paper"
                                                        }
                                                    }}
                                                    className="custom-select"
                                                    disabled={false}
                                                    value={this.state.returnReasonId || -1}
                                                    onChange={this.handleChange}
                                                >
                                                    {this.props.returnReasons &&
                                                        this.props.returnReasons.length > 0 &&
                                                        this.props.returnReasons.map((returnReason, i) => {
                                                            return (
                                                                <MenuItem key={i} className="form-menu-item-select-multiple" value={returnReason.id}>
                                                                    <ListItemText
                                                                        classes={{
                                                                            root: "form-menu-item-select-multiple-list-item-text"
                                                                        }}
                                                                    >
                                                                        {RETURN_SECTION.REASONS[returnReason.code]}
                                                                    </ListItemText>
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    )
                                                </Select>
                                            </div>
                                        </div>
                                        {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "return_reason") && (
                                            <FormHelperText>{this.state.submitErrors.find(e => e.code === "return_reason").label}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="layout vertical footer">
                                        {this.state.returnErrorMessage && <div className="message-box">{this.state.returnErrorMessage}</div>}
                                        <div className="layout vertical buttons-box">
                                            <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                                <button className="flex custom-button negative" onClick={this.handleNoClick}>
                                                    <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                                </button>
                                                <button
                                                    className={`flex custom-button ${this.props.loading ? "loading" : ""}`}
                                                    style={{ float: "right" }}
                                                    onClick={this.props.loading ? null : this.handleYesClick}
                                                >
                                                    <div className="layout vertical center-center inbutton-text">{MISC.SUBMIT}</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            {this.state.returnFinished && (
                                <React.Fragment>
                                    <div className="layout vertical body">
                                        <div className="flex layout horizontal center-center">
                                            <Confirmed fill="#BF0000" />
                                            <p style={{ margin: "0px 10px" }}>{RETURN_SECTION.RETURN_ORDER.SUCCESS_MESSAGE}</p>
                                        </div>
                                    </div>
                                    <div className="layout vertical footer">
                                        <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                            <button className="flex custom-button" onClick={this.handleNoClick}>
                                                <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                            </button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            <DataConflictWindow
                                open={this.state.dataConflictWindowOpen}
                                handleSubmit={this.handleRefreshOrder}
                                heading={DATA_CONFLICT.HEADING}
                                subheading={DATA_CONFLICT.SUB_HEADING}
                                yesText={MISC.REFRESH}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(ReturnOrderWindow);
